// extracted by mini-css-extract-plugin
module.exports = {"inputSegment":"CodeInput_inputSegment__KBLv4","success":"CodeInput_success__2sgIP","error":"CodeInput_error__3wwuq"};